import React from 'react';
import Footer from '../components/Footer/Footer';
import Navbar from '../components/Navbar/Navbar';
import './Layout.css';

const Layout = ({ children, logout, handleWhatsappClick, handleDashboardClick, handleBankClick }) => {
    return (
        <div className="Layout">
            <Navbar
                logout={logout}
                handleWhatsappClick={handleWhatsappClick}
                handleDashboardClick={handleDashboardClick}
                handleBankClick={handleBankClick}
            />
            <div className="LayoutContent">
                {children}
            </div>
            <Footer />
        </div>
    );
};

export default Layout; 
